import { useEffect, useState } from "react";

/**
 * Ansichten der Browser-Version als Hash-Adressen, damit Zurück, Lesezeichen
 * und Neuladen funktionieren – ohne Router-Bibliothek und ohne Server-Regeln:
 *
 *   #/                                   Übersicht
 *   #/kurs/<kurs>                        ein Kurs
 *   #/kurs/<kurs>/<modul>/<lektion>      eine Lektion
 */
export type WebRoute =
  | { type: "home" }
  | { type: "course"; courseId: string }
  | { type: "lesson"; courseId: string; moduleId: string; lessonId: string };

export function parseRoute(hash: string): WebRoute {
  const parts = hash.replace(/^#\/?/, "").split("/").filter(Boolean).map(decodeURIComponent);
  if (parts[0] === "kurs" && parts[1]) {
    if (parts[2] && parts[3]) {
      return { type: "lesson", courseId: parts[1], moduleId: parts[2], lessonId: parts[3] };
    }
    return { type: "course", courseId: parts[1] };
  }
  return { type: "home" };
}

export const href = {
  home: () => "#/",
  course: (courseId: string) => `#/kurs/${encodeURIComponent(courseId)}`,
  lesson: (courseId: string, moduleId: string, lessonId: string) =>
    `#/kurs/${[courseId, moduleId, lessonId].map(encodeURIComponent).join("/")}`,
};

export function useHashRoute(): WebRoute {
  const [route, setRoute] = useState(() => parseRoute(window.location.hash));

  useEffect(() => {
    const update = () => setRoute(parseRoute(window.location.hash));
    window.addEventListener("hashchange", update);
    return () => window.removeEventListener("hashchange", update);
  }, []);

  return route;
}
